import(/* webpackMode: "eager" */ "/home/runner/work/web/web/src/app/not-found.tsx");
